module.exports = __webpack_public_path__ + "static/media/three_marker.6a6febd9.svg";